// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* HEADER COMPONENT STYLES - VANTA INSPIRED    */
/* ============================================= */

.header {
  background-color: white;
  border-bottom: 1px solid #E2E8F0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 200ms ease-in-out;
}

.dark .header {
  background-color: #1E293B;
  border-bottom-color: #334155;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.header-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-transparent {
  background-color: transparent;
  border-bottom-color: transparent;
  box-shadow: none;
}

/* Navigation */
.nav {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1rem 0;
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 2rem;
  padding-right: 2rem;
}

/* Navigation Brand */
.nav-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-right: auto;
}

.nav-brand img {
  height: 2rem;
  width: auto;
}

.nav-brand-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0F172A;
}

.dark .nav-brand-text {
  color: #F8FAFC;
}

/* Navigation Item */
.nav-item {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748B;
  text-decoration: none;
  transition: all 200ms ease-in-out;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;
}

.dark .nav-item {
  color: #CBD5E1;
}

.nav-item:hover {
  color: #0F172A;
  background-color: #F1F5F9;
}

.dark .nav-item:hover {
  color: #F8FAFC;
  background-color: #334155;
}

.nav-item-active {
  color: #2563EB;
  font-weight: 600;
}

.dark .nav-item-active {
  color: #38BDF8;
}

.nav-item-active::after {
  content: '';
  position: absolute;
  bottom: -1rem;
  left: 0.75rem;
  right: 0.75rem;
  height: 2px;
  background-color: #2563EB;
  border-radius: 1px;
}

.dark .nav-item-active::after {
  background-color: #38BDF8;
}

/* Responsive */
@media (max-width: 768px) {
  .nav {
    gap: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .nav-item {
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
  }

  .nav-item-active::after {
    bottom: -0.75rem;
    left: 0.5rem;
    right: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Header.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,gDAAgD;AAChD,kDAAkD;;AAElD;EACE,uBAAuB;EACvB,gCAAgC;EAChC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;EACjC,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":["/* ============================================= */\n/* HEADER COMPONENT STYLES - VANTA INSPIRED    */\n/* ============================================= */\n\n.header {\n  background-color: white;\n  border-bottom: 1px solid #E2E8F0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 200ms ease-in-out;\n}\n\n.dark .header {\n  background-color: #1E293B;\n  border-bottom-color: #334155;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.header-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.header-transparent {\n  background-color: transparent;\n  border-bottom-color: transparent;\n  box-shadow: none;\n}\n\n/* Navigation */\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem 0;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n/* Navigation Brand */\n.nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-right: auto;\n}\n\n.nav-brand img {\n  height: 2rem;\n  width: auto;\n}\n\n.nav-brand-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.dark .nav-brand-text {\n  color: #F8FAFC;\n}\n\n/* Navigation Item */\n.nav-item {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748B;\n  text-decoration: none;\n  transition: all 200ms ease-in-out;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  position: relative;\n}\n\n.dark .nav-item {\n  color: #CBD5E1;\n}\n\n.nav-item:hover {\n  color: #0F172A;\n  background-color: #F1F5F9;\n}\n\n.dark .nav-item:hover {\n  color: #F8FAFC;\n  background-color: #334155;\n}\n\n.nav-item-active {\n  color: #2563EB;\n  font-weight: 600;\n}\n\n.dark .nav-item-active {\n  color: #38BDF8;\n}\n\n.nav-item-active::after {\n  content: '';\n  position: absolute;\n  bottom: -1rem;\n  left: 0.75rem;\n  right: 0.75rem;\n  height: 2px;\n  background-color: #2563EB;\n  border-radius: 1px;\n}\n\n.dark .nav-item-active::after {\n  background-color: #38BDF8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .nav {\n    gap: 1rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .nav-item {\n    padding: 0.375rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .nav-item-active::after {\n    bottom: -0.75rem;\n    left: 0.5rem;\n    right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
